<template>
    <v-group
            @mouseover="hover(true)"
            @mouseout="hover(false)"
            @dblclick="openEditPopup"
    >
        <v-line :config="lineConfig"></v-line>

        <LineSize v-if="!lineLengthIsHidden"
                  :fromPoint="fromPoint"
                  :toPoint="toPoint"
                  :color="color"
                  :sizeFlip="fromPoint.sizeFlip"
        ></LineSize>
    </v-group>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex';
    import LineSize from "./LineSize";

    export default {
        name: "TrimLine",

        components: {
            LineSize
        },

        props: [
            'id',
            'type',
            'fromPoint',
            'toPoint',
            'lineLengthIsHidden',
            'lineColor',
            'lineColorHover',
        ],

        computed: {
            ...mapState('editor', [
                'drawingState',
            ]),

            lineConfig() {
                let xFrom = this.fromPoint.x;
                let yFrom = this.fromPoint.y;
                let xTo = this.toPoint.x;
                let yTo = this.toPoint.y;

                let points = [xFrom, yFrom, xTo, yTo];

                return {
                    id: `line-${this.id}`,
                    name: 'DrawingLine',
                    points,
                    stroke: this.color,
                    strokeWidth: 3,
                    hitStrokeWidth: 5,
                    lineCap: 'round',
                    lineJoin: 'round',
                }
            },

            isHovered() {
                return this.fromPoint['isLineHover']
            },

            color() {
                let hovered = !this.drawingState && this.isHovered;

                return hovered ? this.lineColorHover : this.lineColor;
            },

        },

        methods: {
            ...mapMutations('line', [
                'setLineIsHover',
            ]),

            ...mapActions('editPopup', [
                'openLineEditPopup',
            ]),

            openEditPopup() {
                let lineData = {
                    id: this.id,
                    type: this.type,
                    fromPoint: this.fromPoint,
                    toPoint: this.toPoint,
                };

                this.openLineEditPopup(lineData);
            },

            hover(isHover) {
                this.setLineIsHover({ point: this.fromPoint, isHover });
            },

        },

    }
</script>

<style scoped>

</style>